import { cn } from '@lib/utils';

interface AttentionDotProps {
  /**
   * Screen-reader text announcing what the dot signals (e.g. "(new requests)").
   * Omit for a purely decorative dot — it's then hidden from assistive tech.
   */
  label?: string;
  className?: string;
}

/**
 * A small red status dot flagging that something needs attention — pending We
 * Met requests, unseen event activity, etc. Pairs the color-only visual with
 * optional sr-only text so the signal stays accessible.
 */
export const AttentionDot = ({ label, className }: AttentionDotProps) => (
  <>
    <span
      aria-hidden="true"
      className={cn('h-1.5 w-1.5 shrink-0 rounded-full bg-destructive', className)}
    />
    {label ? <span className="sr-only">{label}</span> : null}
  </>
);
